export const environment = {
    production: false,
    apiUrl: '/api',
    googleClientId: '427659148041-253dhlhlg3jv0a16srf4skkqk13ttqad.apps.googleusercontent.com',
    recaptchaSiteKey: '6Lfim1wtAAAAAGUxg1viJDRCRv-2Hs9BCpX9xdv_',
};
